import React from "react";
import { Chart } from "react-google-charts";


export const options = {

  redFrom: 90,
  redTo: 100,
  yellowFrom: 75,
  yellowTo: 90,
  minorTicks: 5,
};

export function GaugeChart2({label,value}) {
  
const data=[
  ["Label", "Value"],
  [label,value]];
  
  return (
    <Chart
      chartType="Gauge"
      data={data}
      options={options}
    />
  );
}
